// types
import {PaymentSystemActionTypes, SalePaymentSystemState, PaymentSystemType} from "./types";

export const NewSalePaymentSystemItem:PaymentSystemType = {
  enabled: true,
  name: '',
  order: 500
}

export const INIT_STATE_SALE_PAYMENT_SYSTEM: SalePaymentSystemState = {
  items: [],
  rightModalShow: false,
  removeModalShow: false,
  selectedItem: NewSalePaymentSystemItem,
  modalEditTitle: '',
  isSending: false,
  isFetched: false,
  isLoading: false,
  isNeedReload: false
};

const SalePaymentSystem = (state = INIT_STATE_SALE_PAYMENT_SYSTEM, action: any) => {
  switch (action.type) {
    case PaymentSystemActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case PaymentSystemActionTypes.GET_SALE_PAYMENT_SYSTEMS:
          return {
            ...state,
            items: action.payload.data.items,
            meta: action.payload.data.meta,
            isFetched: true,
            isLoading: false,
            isNeedReload: false
          };
        case PaymentSystemActionTypes.UPDATE_SALE_PAYMENT_SYSTEM:
          return {
            ...state,
            selectedItem: NewSalePaymentSystemItem,
            rightModalShow: false,
            isSending: false,
            isNeedReload: true
          };
        case PaymentSystemActionTypes.REMOVE_SALE_PAYMENT_SYSTEM:
          return {
            ...state,
            selectedItem: NewSalePaymentSystemItem,
            removeModalShow: false,
            isNeedReload: true
          };
        default:
          return { ...state };
      }
    case PaymentSystemActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case PaymentSystemActionTypes.GET_SALE_PAYMENT_SYSTEMS:
          return {
            ...state,
            isFetched: false,
            isLoading: false,
            isNeedReload: false
          };
        case PaymentSystemActionTypes.UPDATE_SALE_PAYMENT_SYSTEM:
          return {
            ...state,
            isSending: false
          };
        case PaymentSystemActionTypes.REMOVE_SALE_PAYMENT_SYSTEM:
          return {
            ...state,
            removeModalShow: false
          };
        default:
          return { ...state };
      }
    case PaymentSystemActionTypes.EDIT_SALE_PAYMENT_SYSTEM:
      return {
        ...state,
        selectedItem: action.payload.data,
        modalEditTitle: action.payload.modalEditTitle,
        rightModalShow: true
      }
    case PaymentSystemActionTypes.RIGHT_MODAL_SHOW:
      return {
        ...state,
        selectedItem: NewSalePaymentSystemItem,
        modalEditTitle: action.payload.modalEditTitle,
        rightModalShow: true
      }
    case PaymentSystemActionTypes.REMOVE_SALE_PAYMENT_SYSTEM_MODAL_SHOW:
      return {
        ...state,
        selectedItem: action.payload.data,
        modalEditTitle: action.payload.modalEditTitle,
        removeModalShow: true
      }
    case PaymentSystemActionTypes.REMOVE_SALE_PAYMENT_SYSTEM_MODAL_HIDE:
      return {
        ...state,
        selectedItem: NewSalePaymentSystemItem,
        removeModalShow: false
      }
    case PaymentSystemActionTypes.RIGHT_MODAL_HIDE:
      return {
        ...state,
        rightModalShow: false
      }
    case PaymentSystemActionTypes.UPDATE_SALE_PAYMENT_SYSTEM:
      return {
        ...state,
        isSending: true
      };
    case PaymentSystemActionTypes.GET_SALE_PAYMENT_SYSTEMS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return { ...state };
  }
};

export default SalePaymentSystem;
